// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.iframe-container[data-v-639bc103] {\n  position: relative;\n  overflow: hidden;\n}\n.responsive-iframe[data-v-639bc103] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n@media screen and (max-width: 400px) {\ndiv[data-v-639bc103] .v-dialog {\n    margin: 24px 0px !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
